// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__a55Hm","btnSearch":"styles_btnSearch__7Zoby","searchIcon":"styles_searchIcon__HqtEc"};